<template>
    <v-dialog 
        v-model="dialog" 
        width="600" 
        @click:outside="closeModal"
    >
        <v-card class="custom-card pb-120" rounded="0">
            <v-toolbar color="secondary" flat class="white--text">
                <v-toolbar-title class="font-weight-bold"> {{ url?.match(/.*\/(.*)$/)[1] }}</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn icon class="white--text" @click="closeModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="py-1 px-1">
                <v-img
                    :src="url"
                    lazy-src="/img/Loading_icon.gif"
                    contain
                    max-height="300"
                >
                    <template v-slot:placeholder>
                        <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                        >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                            ></v-progress-circular>
                        </v-row>
                    </template>
                </v-img>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
  
<script>

    import loadingMixin from "@/mixins/LoadingMixin";
    import generalMixin from "@/mixins/GeneralMixin";

  
    export default {
        computed: {
            dialog() {
                return this.dialogU;
            },
            currentRouteName() {
                return this.$route.name;
            }
        },
        data() {
            return {

            };
        },
        methods: {
            closeModal() {
                this.$emit("image-preview-closed");
            },
        },
        props: {
            dialogU: {
                type: Boolean,
                required: true,
            },
            url: {
                type: String,
                required: true
            }
        },
        mixins: [
            loadingMixin, 
            generalMixin
        ],
    };
  </script>
  
  <style lang="scss">
        .hr-tag {
            display: flex;
            flex-direction: row;
        }
          
        .hr-tag:before,
        .hr-tag:after {
            content: "";
            flex: 1 1;
            border-bottom: 1px solid #D9D9D9;
            margin: auto;
            padding: 0px;
            width: 50% !important;
        }
  </style>
  